import { Storage } from 'aws-amplify';
import uuid from "react-uuid";
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../config/aws-export';

async function S3UploadHook(file,path) {
    Amplify.configure(awsConfig)
    const key = `${path}/${uuid()}/${file.name}`;
    
    try {
        const result = await Storage.put(key,file, {
            contentType: file.type,
            acl: "public-read",
            level: 'public',
        },);
        return result.key
    } catch (error) {
        console.log("error",error)

    }
   
}

export default S3UploadHook;